import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConnectionService } from '../../services/connection.service';

@Component({
  selector: 'app-email-tests',
  templateUrl: './email-tests.component.html',
  styleUrls: ['./email-tests.component.scss']
})
export class EmailTestsComponent {

  constructor(
    private http: HttpClient,
    private connectionService: ConnectionService,
    ) { }

  dryRunResult: any = null;
  sendResult: any = null;
  sendTo: string = "";
  loadingDryRun = false;
  loadingSend = false;

  triggerDryRun() {
    this.loadingDryRun = true;
    this.dryRunResult = null;

    this.http.get(`${this.connectionService.address}/test/m365-email/dry-run`).subscribe({
      next: (result) => {
        this.dryRunResult = result;
        this.loadingDryRun = false;
      },
      error: (err) => {
        this.dryRunResult = err?.error || err;
        this.loadingDryRun = false;
      }
    });
  }

  sendTestEmail() {
    const trimmed = (this.sendTo || '').trim();
    if (!trimmed) {
      this.sendResult = { error: "Please enter one or more recipients (comma separated)." };
      return;
    }

    this.loadingSend = true;
    this.sendResult = null;

    const encoded = encodeURIComponent(trimmed);
    this.http.get(`${this.connectionService.address}/test/m365-email?to=${encoded}`).subscribe({
      next: (result) => {
        this.sendResult = result;
        this.loadingSend = false;
      },
      error: (err) => {
        this.sendResult = err?.error || err;
        this.loadingSend = false;
      }
    });
  }
}
